
	import { defineComponent } from 'vue';

	import LoadingSpinner from '@/ChildrenComponents/LoadingSpinner.vue';
	import IncorrectPermissions from '@/ChildrenComponents/IncorrectPermissions.vue';
	import FiscalYearReportSearch from '@/ChildrenComponents/Reports/FiscalYearReportSearch.vue';
    import ReportExporter from '@/ChildrenComponents/ReportExporter.vue'

	import { ComponentType } from '@/Enums/ComponentType';

	import { IInternalUser } from '@/Models/IInternalUser';
	import { IUniqueParticipantReport, IFiscalYearReportSearch } from '@/Models/Report/IPhaseReport';
	import { IDataTableHeader } from '@/Models/IDataTableHeader';

    import { ReportService } from '@/Services/Report/report-service';
    import { doesUserRoleHaveComponentViewPermissions } from '@/Services/Helper/component-permissions-helper';
	import { useUserStore } from '@/Services/Store/user-store';

	export default defineComponent({
		name: 'unique-participant-report',
		components: { LoadingSpinner, IncorrectPermissions, FiscalYearReportSearch, ReportExporter },
		setup(): { currentUser: IInternalUser | null } {
			const userStoreInstance = useUserStore();
			return { currentUser: userStoreInstance.$state.cstInternalUser };
		},
		data () {
			return {
				reportData: [] as IUniqueParticipantReport[],
				isLoading: false,
				isSearching: false,
				headers: [
                    { title: "Program", key: "programName", sortable: true, align: "start" },
                    { title: "Q1", key: "q1", sortable: true, align: "start" },
                    { title: "Q2", key: "q2", sortable: true, align: "start" },
                    { title: "Q3", key: "q3", sortable: true, align: "start" },
                    { title: "Q4", key: "q4", sortable: true, align: "start" },
                    { title: "Total Participants", key: "total", sortable: true, align: "start" },
				] as IDataTableHeader[],
			}
		},
		methods: {
			getReportData(searchDto: IFiscalYearReportSearch) {
				this.isSearching = true;
				ReportService.getUniqueParticipantReportData(searchDto).then(results => this.reportData = results).finally(() => this.isSearching = false);
			}
		},
		computed: {
			canView(): boolean {
				return doesUserRoleHaveComponentViewPermissions(this.currentUser?.attachedRoles ?? [], ComponentType.Report);
			},
		},
	});
